import { TAvatarBackgroundColorIndex } from '@gem/ui-kit';

export interface IFormData {
  title: string;
  allDay: boolean;
  start: Date;
  end: Date;
  startTime: string;
  endTime: string;
  reminders: Array<{ value: string }>;
  repeat: string;
  description: string;
  participants: Array<string>;
}

export interface ICalendarEventSubmitData extends IFormData {
  callLink: string;
}

export interface IFormUser {
  id: string;
  email: string;
  displayName: string;
  avatarUrl: string;
  avatarColorIndex: TAvatarBackgroundColorIndex;
}

export enum UnitEnum {
  Minutes = 'minutes',
  Hours = 'hours',
  Days = 'days',
  Weeks = 'weeks',
}
